import { MyEarningContainer } from 'modules/MyEarning'
import React from 'react'

type Props = {}

const MyEarnings = (props: Props) => {
    return (
        <MyEarningContainer />
    )
}

export default MyEarnings